// const backendBaseUrl = 'http://localhost:8181'; // dev
// const backendBaseUrl = 'http://localhost/agri_portal/v2/api/public'; // dev wamp server
// const backendBaseUrl = 'http://backend-qlnongnghiep.vnisa.vn'; // demo 
// const backendBaseUrl = 'https://htttnongnghiep.tiengiang.gov.vn:8081'; // product port domain
const backendBaseUrl = 'https://api-htttnongnghiep.tiengiang.gov.vn'; // product official domain
// const agriDataBackUrl = 'https://localhost:9080/agri-tgg/api'; // dev agridata
// const agriDataBackUrl = 'https://dulieunongnghiep.tiengiang.gov.vn:8081/agri-tgg/api'; // product agridata port domain
const agriDataBackUrl = 'https://api-dulieunongnghiep.tiengiang.gov.vn/agri-tgg/api'; // product agridata official domain

const config = {
  beUrl: backendBaseUrl,
  agriDataBackUrl: agriDataBackUrl,
  ajaxUploadUrl: `${backendBaseUrl}/admin/api/upload`,
  api: `${backendBaseUrl}/api/v1`,
  sysTitle: 'Kết Nối Nông Nghiệp, Nông Dân, Nông Thôn',
  provinceName: 'Tỉnh Tiền Giang',
  envUrl: 'http://quantrac.vnisa.vn',
  gisMap: {
    url: 'https://gisnongnghiep.tiengiang.gov.vn',
    account: 'eyJ1c2VybmFtZSI6ImVtYmVkX25uIiwicGFzc3dvcmQiOiJlbWJlZEAxMjMifQ=='
  },
  gmap: {
    key: 'AIzaSyA8BERyg_QdYccc9oMsRKbBI7QTVKJiY-M',
    libraries: 'places'
  },
  support: {
    hotline: '0813 756 787',
    zalo: '0354045644',
  }
};

global.config = config;

export default config;